import useSWR from "swr";
import { PaginationQuery } from "../../types";
import { buildUrl, useApi } from "../api";
import { CustomError } from "../errors";
import { SearchLockStopsResponse } from "./types";

/**
 * Lock-item inputs backing the same lockstop-compatibility rule the backend
 * already applies during configuration generation (filterLockstopsByMapping)
 * — passed here so the lockstop select can be narrowed to compatible items
 * too, without duplicating that rule on the frontend.
 */
export type LockstopCompatibilityFilter = {
  lockItemId?: string | null;
  secondLockItemId?: string | null;
};

/** Fetches lockstop catalog options, optionally narrowed to those compatible with the given lock(s). */
export const useLockStops = (
  query: PaginationQuery,
  signal: AbortSignal,
  isAdmin?: boolean,
  compatibility?: LockstopCompatibilityFilter,
) => {
  const api = useApi();
  const prefix = isAdmin ? "/admin" : "";
  let url = buildUrl(`${prefix}/modules/lock_calculator/selects/lock-stops`, query);
  if (compatibility) {
    const extraParams: Record<string, string> = {};
    for (const [key, value] of Object.entries(compatibility)) {
      if (value !== null && value !== undefined) extraParams[key] = String(value);
    }
    const search = new URLSearchParams(extraParams).toString();
    if (search) url += (url.includes("?") ? "&" : "?") + search;
  }
  return useSWR<SearchLockStopsResponse, CustomError, string>(url, (requestUrl) =>
    api.get<SearchLockStopsResponse>({ url: requestUrl, signal }),
  );
};
